import { Injectable } from '@angular/core';

import {
  CmsService,
  Occ,
  PageDescriptionResolver,
  PageMetaResolver,
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import PageType = Occ.PageType;

@Injectable({
  providedIn: 'root',
})
export class DpNewsPageMetaResolver
  extends PageMetaResolver
  implements PageTitleResolver, PageDescriptionResolver, PageRobotsResolver {
  constructor(protected cms: CmsService) {
    super();
    this.pageType = <PageType>'NewsPage';
    this.pageTemplate = 'NewsPageTemplate';
  }

  resolveDescription(): Observable<string | undefined> {
    return this.cms.getCurrentPage().pipe(map((page) => page?.description));
  }

  resolveTitle(): Observable<string | undefined> {
    return this.cms.getCurrentPage().pipe(map((page) => page?.title));
  }

  resolveRobots(): Observable<PageRobotsMeta[] | undefined> {
    return this.cms.getCurrentPage().pipe(map((page) => page?.robots));
  }
}
